import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Locale } from '../Locale/Locale';
import { ConfigService, LocalesService } from '../Locale/locales.service';
import { iOSPopupModal } from './iOSPopupModal.component';
import { LocaleComponent } from '../Locale/locale.component';
import { MatTooltip } from '@angular/material/tooltip';
import { AsyncPipe } from '@angular/common';
import { LocaleByKeyPipe } from '../../localePipe';

@Component({
    standalone: true,
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    imports: [LocaleComponent, MatTooltip, AsyncPipe, LocaleByKeyPipe]
})
export class TooltipComponent implements OnInit {
  // The locale key and view for the content that is inside of the tooltip
  @Input() localeKey!: string;
  @Input() localeView: string | null = null;

  // The locale key and view for what the tooltip is attached to 
  // This is what you have to hover over to get the tooltip to pop up
  @Input() tooltipKey!: string;
  @Input() tooltipView!: string;

  observableLocales$!: Observable<Locale[]>;
  iOS = false;
  tooltipPosition = "below";

    constructor(private localeService: LocalesService, public dialog: MatDialog, private configservice: ConfigService) { }

  ngOnInit() {
    this.observableLocales$ = this.getPlaceholderLocaleStrings();
      this.iOS = this.iOS_check();
  }

  iOS_check(): boolean {
    const devices = ['iPhone', 'iPad', 'iPod'];
    while (devices.length) {
      if (navigator.platform === devices.pop()) {
        return true;
      }
    }
    return false;
  }

  openTooltip(): void {
    const key = this.localeKey;
    const view = this.localeView;
    this.dialog.open(iOSPopupModal, {
      width: '500px',
      data: { key, view }
    });
  }

    getPlaceholderLocaleStrings() {
        return this.localeService.getLocalesByLang(this.configservice.languagerequested)
          .pipe(
            map((locales: Locale[]) => {
              return locales.filter((item) => {
                  return item.key.endsWith('TOOLTIP') && (item.view === null || item.view === undefined || item.view === this.localeView);
              });
            })
          );
  }
}
